globalThis.meowcart = {
  api_url: window.MEOWCART_API_URL || "https://pro-crocs-loyalty.web.app/api/the1",
  endpoints: {
    idm: {
      loginable: "/idm/loginable",
      login: "/idm/login",
      loginWithOtp: "/idm/login-methods/otp",
      prepareRegister: "/idm/prepare-register",
      confirmRegister: "/idm/confirm-register",
      completeRegister: "/idm/complete-register",
      newAccount: "/idm/new-account",
      verifyNewAccount: "/idm/new-account/verify",
      myProfile: "/idm/my-profile",
      updateProfile: "/idm/update-profile",
      updateProfileEmail: "/idm/update-profile/email",
      updateProfileEmailConfirm: "/idm/update-profile/email/confirm",
      updateProfilePhone: "/idm/update-profile/phone",
      updateProfilePhoneConfirm: "/idm/update-profile/phone/confirm",
      securityQuestions: "/idm/security-questions",
      createPin: "/idm/pin/create",
      changePin: "/idm/pin/change",
      verifyPin: "/idm/pin/verify",
      securityQuestionChange: "/idm/sq/change",
      recoveryEmail: "/idm/recovery/email",
      recoveryZalo: "/idm/recovery/zalo",
      recoverySecurityQuestion: "/idm/recovery/security-question",
      recoverySecurityQuestionConfirm:
        "/idm/recovery/security-question/confirm",
      customerEmail: "/idm/customer-email",
    },
    mdw: {
      myWallet: "/mdw/my-wallet",
      myPoints: "/mdw/my-points",
      myPointsHistory: "/mdw/my-points/history",
      exchangePoints: "/mdw/my-points/exchange",
      getCoupons: "/mdw/coupons/get",
      syncCoupons: "/mdw/coupons/sync",
      searchCampaigns: "/mdw/campaigns/search",
      collectVoucher: "/mdw/campaigns/collect",
    },
    shopify: {
      updateDiscount: "/shopify/cart/discount/update",
    },
    customer: {
      getCustomerById: "/customer/:id",
    },
    portal: {
      getConsents: "/portal/consents",
      userConsent: "/idm/user/consent",
    },
  },
};
